export const BoothColors: Record<string, string> = {
  "課外活動展": "#ED7B7E",
  "文学部展": "#BA9A7C",
  "農学部展": "#87C57A",
  "工学部展": "#76A1D6",
  "経営学部展": "#AADBE2",
  "教育学部展": "#009FB6",
  "芸術学部展": "#CBA0C8",
  "リベラルアーツ学部展": "#EF8FB5",
  "観光学部展": "#F8CD7E",
  "研究所": "#7A9A4F",
  "大学関連団体": "#FAEE00",
}